export const request = (url, requestInit = {}) => {
    const { timeout, ...restInit } = requestInit;
    if (timeout != null) {
        const controller = new AbortController();
        restInit.signal = controller.signal;
        window.setTimeout(() => controller.abort(), timeout);
    }
    return fetch(url, restInit);
};
